// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Загальні стилі для сторінок відновлення паролю */
.forgot-password-page,
.reset-password-page {
  min-height: calc(100vh - 90px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.forgot-password-container,
.reset-password-container {
  width: 100%;
  max-width: 480px;
}

/* Заголовки */
.forgot-password-header,
.reset-password-header {
  text-align: center;
  margin-bottom: 32px;
}

.forgot-password-title,
.reset-password-title {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 2.2rem;
  font-weight: 700;
  color: #121212;
  margin-bottom: 12px;
  line-height: 1.2;
}

.forgot-password-subtitle,
.reset-password-subtitle {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1rem;
  color: #666;
  line-height: 1.5;
  max-width: 400px;
  margin: 0 auto;
}

/* Карточки */
.forgot-password-card,
.reset-password-card {
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  border: 2px solid #121212;
  margin-bottom: 24px;
}

/* Форми */
.forgot-password-form,
.reset-password-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Загальні стилі форми */
.form-group {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 0.9rem;
  font-weight: 500;
  color: #121212;
  margin-bottom: 8px;
}

.form-input {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1rem;
  padding: 14px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
  transition: all 0.3s ease;
  outline: none;
}

.form-input:focus {
  border-color: #121212;
  background: white;
  box-shadow: 0 0 0 3px rgba(18, 18, 18, 0.1);
}

.form-input:disabled {
  background: #f0f0f0;
  cursor: not-allowed;
  opacity: 0.7;
}

/* Підказка для пароля */
.password-hint {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 0.75rem;
  color: #888;
  margin-top: 4px;
  margin-left: 4px;
}

/* Повідомлення */
.success-message,
.error-message {
  font-family: 'IBM Plex Mono', monospace;
  padding: 14px 16px;
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  line-height: 1.4;
}

.success-message {
  color: #0f5132;
  background: #d1e7dd;
  border: 1px solid #badbcc;
}

.error-message {
  color: #842029;
  background: #f8d7da;
  border: 1px solid #f5c2c7;
}

.success-icon,
.error-icon,
.invalid-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-top: 2px;
}

.success-icon {
  color: #0f5132;
}

.error-icon {
  color: #842029;
}

.invalid-icon {
  color: #664d03;
  width: 48px;
  height: 48px;
}

/* Повідомлення про перенаправлення */
.redirect-message {
  font-size: 0.85rem;
  margin-top: 6px;
  opacity: 0.8;
  font-style: italic;
}

/* Повідомлення про недійсний токен */
.invalid-token-message {
  text-align: center;
  padding: 20px;
}

.invalid-token-message h3 {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1.5rem;
  color: #664d03;
  margin: 16px 0 12px;
}

.invalid-token-message p {
  font-family: 'IBM Plex Mono', monospace;
  color: #666;
  margin-bottom: 24px;
  line-height: 1.5;
}

/* Кнопки */
.submit-button,
.request-new-link-button {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1rem;
  font-weight: 600;
  padding: 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  width: 100%;
  margin-top: 8px;
}

.submit-button {
  background: #121212;
  color: white;
  border: 2px solid #121212;
}

.submit-button:hover:not(:disabled) {
  background: #333;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.request-new-link-button {
  background: #ffc107;
  color: #121212;
  border: 2px solid #ffc107;
}

.request-new-link-button:hover {
  background: #e0a800;
  border-color: #e0a800;
  transform: translateY(-1px);
}

/* Кнопки в футері */
.forgot-password-footer,
.reset-password-footer {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.back-to-login-button,
.try-again-button {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 0.875rem;
  color: #666;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.back-to-login-button:hover {
  color: #121212;
  background: rgba(18, 18, 18, 0.05);
}

.try-again-button {
  color: #121212;
  font-weight: 500;
  text-decoration: underline;
  padding: 0;
}

.try-again-button:hover {
  text-decoration: none;
}

/* Додаткова інформація */
.additional-info,
.reset-password-footer {
  text-align: center;
  padding: 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.8);
}

.additional-info p {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 0.875rem;
  color: #666;
  margin: 0;
}

/* Індикатор завантаження */
.button-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Адаптивні стилі */
@media (max-width: 768px) {
  .forgot-password-page,
  .reset-password-page {
    padding: 16px;
    margin-top: 60px;
  }
  
  .forgot-password-title,
  .reset-password-title {
    font-size: 1.8rem;
  }
  
  .forgot-password-card,
  .reset-password-card {
    padding: 32px 24px;
    border-radius: 12px;
  }
  
  .forgot-password-form,
  .reset-password-form {
    gap: 20px;
  }
  
  .form-input {
    padding: 12px 14px;
    font-size: 0.95rem;
  }
  
  .submit-button {
    padding: 14px;
  }
}

@media (max-width: 480px) {
  .forgot-password-container,
  .reset-password-container {
    max-width: 100%;
  }
  
  .forgot-password-title,
  .reset-password-title {
    font-size: 1.5rem;
  }
  
  .forgot-password-subtitle,
  .reset-password-subtitle {
    font-size: 0.9rem;
  }
  
  .forgot-password-card,
  .reset-password-card {
    padding: 24px 20px;
    border-width: 1.5px;
  }
  
  .forgot-password-header,
  .reset-password-header {
    margin-bottom: 24px;
  }
  
  .form-input {
    font-size: 0.9rem;
  }
  
  .success-message,
  .error-message {
    font-size: 0.85rem;
    padding: 12px;
  }
}

@media (max-width: 360px) {
  .forgot-password-page,
  .reset-password-page {
    padding: 12px;
  }
  
  .forgot-password-card,
  .reset-password-card {
    padding: 20px 16px;
  }
  
  .forgot-password-title,
  .reset-password-title {
    font-size: 1.3rem;
  }
  
  .form-input {
    padding: 10px 12px;
  }
}

/* Анімації */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.forgot-password-container,
.reset-password-container {
  animation: fadeIn 0.4s ease-out;
}`, "",{"version":3,"sources":["webpack://./src/components/login/ForgotPassword.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;;EAEE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6DAA6D;AAC/D;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA,cAAc;AACd;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,uCAAuC;EACvC,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,aAAa;AACb;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,UAAU;AACV;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;;EAEE,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,WAAW;AACX;;EAEE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;;EAEE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,oBAAoB;AACpB;EACE;;IAEE,aAAa;IACb,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;IAEE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;IAClB,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,aAAa;AACb;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,+BAA+B;AACjC","sourcesContent":["/* Загальні стилі для сторінок відновлення паролю */\r\n.forgot-password-page,\r\n.reset-password-page {\r\n  min-height: calc(100vh - 90px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\r\n}\r\n\r\n.forgot-password-container,\r\n.reset-password-container {\r\n  width: 100%;\r\n  max-width: 480px;\r\n}\r\n\r\n/* Заголовки */\r\n.forgot-password-header,\r\n.reset-password-header {\r\n  text-align: center;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.forgot-password-title,\r\n.reset-password-title {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 2.2rem;\r\n  font-weight: 700;\r\n  color: #121212;\r\n  margin-bottom: 12px;\r\n  line-height: 1.2;\r\n}\r\n\r\n.forgot-password-subtitle,\r\n.reset-password-subtitle {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 1rem;\r\n  color: #666;\r\n  line-height: 1.5;\r\n  max-width: 400px;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* Карточки */\r\n.forgot-password-card,\r\n.reset-password-card {\r\n  background: white;\r\n  border-radius: 16px;\r\n  padding: 40px;\r\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\r\n  border: 2px solid #121212;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n/* Форми */\r\n.forgot-password-form,\r\n.reset-password-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n}\r\n\r\n/* Загальні стилі форми */\r\n.form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.form-label {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  color: #121212;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.form-input {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 1rem;\r\n  padding: 14px 16px;\r\n  border: 2px solid #e0e0e0;\r\n  border-radius: 8px;\r\n  background: #fafafa;\r\n  transition: all 0.3s ease;\r\n  outline: none;\r\n}\r\n\r\n.form-input:focus {\r\n  border-color: #121212;\r\n  background: white;\r\n  box-shadow: 0 0 0 3px rgba(18, 18, 18, 0.1);\r\n}\r\n\r\n.form-input:disabled {\r\n  background: #f0f0f0;\r\n  cursor: not-allowed;\r\n  opacity: 0.7;\r\n}\r\n\r\n/* Підказка для пароля */\r\n.password-hint {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 0.75rem;\r\n  color: #888;\r\n  margin-top: 4px;\r\n  margin-left: 4px;\r\n}\r\n\r\n/* Повідомлення */\r\n.success-message,\r\n.error-message {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  padding: 14px 16px;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  line-height: 1.4;\r\n}\r\n\r\n.success-message {\r\n  color: #0f5132;\r\n  background: #d1e7dd;\r\n  border: 1px solid #badbcc;\r\n}\r\n\r\n.error-message {\r\n  color: #842029;\r\n  background: #f8d7da;\r\n  border: 1px solid #f5c2c7;\r\n}\r\n\r\n.success-icon,\r\n.error-icon,\r\n.invalid-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n  flex-shrink: 0;\r\n  margin-top: 2px;\r\n}\r\n\r\n.success-icon {\r\n  color: #0f5132;\r\n}\r\n\r\n.error-icon {\r\n  color: #842029;\r\n}\r\n\r\n.invalid-icon {\r\n  color: #664d03;\r\n  width: 48px;\r\n  height: 48px;\r\n}\r\n\r\n/* Повідомлення про перенаправлення */\r\n.redirect-message {\r\n  font-size: 0.85rem;\r\n  margin-top: 6px;\r\n  opacity: 0.8;\r\n  font-style: italic;\r\n}\r\n\r\n/* Повідомлення про недійсний токен */\r\n.invalid-token-message {\r\n  text-align: center;\r\n  padding: 20px;\r\n}\r\n\r\n.invalid-token-message h3 {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 1.5rem;\r\n  color: #664d03;\r\n  margin: 16px 0 12px;\r\n}\r\n\r\n.invalid-token-message p {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  color: #666;\r\n  margin-bottom: 24px;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Кнопки */\r\n.submit-button,\r\n.request-new-link-button {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  padding: 16px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  border: none;\r\n  width: 100%;\r\n  margin-top: 8px;\r\n}\r\n\r\n.submit-button {\r\n  background: #121212;\r\n  color: white;\r\n  border: 2px solid #121212;\r\n}\r\n\r\n.submit-button:hover:not(:disabled) {\r\n  background: #333;\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.submit-button:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.request-new-link-button {\r\n  background: #ffc107;\r\n  color: #121212;\r\n  border: 2px solid #ffc107;\r\n}\r\n\r\n.request-new-link-button:hover {\r\n  background: #e0a800;\r\n  border-color: #e0a800;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n/* Кнопки в футері */\r\n.forgot-password-footer,\r\n.reset-password-footer {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.back-to-login-button,\r\n.try-again-button {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 0.875rem;\r\n  color: #666;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 6px 12px;\r\n  border-radius: 4px;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.back-to-login-button:hover {\r\n  color: #121212;\r\n  background: rgba(18, 18, 18, 0.05);\r\n}\r\n\r\n.try-again-button {\r\n  color: #121212;\r\n  font-weight: 500;\r\n  text-decoration: underline;\r\n  padding: 0;\r\n}\r\n\r\n.try-again-button:hover {\r\n  text-decoration: none;\r\n}\r\n\r\n/* Додаткова інформація */\r\n.additional-info,\r\n.reset-password-footer {\r\n  text-align: center;\r\n  padding: 16px;\r\n  border-radius: 8px;\r\n  background: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n.additional-info p {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 0.875rem;\r\n  color: #666;\r\n  margin: 0;\r\n}\r\n\r\n/* Індикатор завантаження */\r\n.button-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n}\r\n\r\n.spinner {\r\n  width: 16px;\r\n  height: 16px;\r\n  border: 2px solid rgba(255, 255, 255, 0.3);\r\n  border-radius: 50%;\r\n  border-top-color: white;\r\n  animation: spin 1s ease-in-out infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n/* Адаптивні стилі */\r\n@media (max-width: 768px) {\r\n  .forgot-password-page,\r\n  .reset-password-page {\r\n    padding: 16px;\r\n    margin-top: 60px;\r\n  }\r\n  \r\n  .forgot-password-title,\r\n  .reset-password-title {\r\n    font-size: 1.8rem;\r\n  }\r\n  \r\n  .forgot-password-card,\r\n  .reset-password-card {\r\n    padding: 32px 24px;\r\n    border-radius: 12px;\r\n  }\r\n  \r\n  .forgot-password-form,\r\n  .reset-password-form {\r\n    gap: 20px;\r\n  }\r\n  \r\n  .form-input {\r\n    padding: 12px 14px;\r\n    font-size: 0.95rem;\r\n  }\r\n  \r\n  .submit-button {\r\n    padding: 14px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .forgot-password-container,\r\n  .reset-password-container {\r\n    max-width: 100%;\r\n  }\r\n  \r\n  .forgot-password-title,\r\n  .reset-password-title {\r\n    font-size: 1.5rem;\r\n  }\r\n  \r\n  .forgot-password-subtitle,\r\n  .reset-password-subtitle {\r\n    font-size: 0.9rem;\r\n  }\r\n  \r\n  .forgot-password-card,\r\n  .reset-password-card {\r\n    padding: 24px 20px;\r\n    border-width: 1.5px;\r\n  }\r\n  \r\n  .forgot-password-header,\r\n  .reset-password-header {\r\n    margin-bottom: 24px;\r\n  }\r\n  \r\n  .form-input {\r\n    font-size: 0.9rem;\r\n  }\r\n  \r\n  .success-message,\r\n  .error-message {\r\n    font-size: 0.85rem;\r\n    padding: 12px;\r\n  }\r\n}\r\n\r\n@media (max-width: 360px) {\r\n  .forgot-password-page,\r\n  .reset-password-page {\r\n    padding: 12px;\r\n  }\r\n  \r\n  .forgot-password-card,\r\n  .reset-password-card {\r\n    padding: 20px 16px;\r\n  }\r\n  \r\n  .forgot-password-title,\r\n  .reset-password-title {\r\n    font-size: 1.3rem;\r\n  }\r\n  \r\n  .form-input {\r\n    padding: 10px 12px;\r\n  }\r\n}\r\n\r\n/* Анімації */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.forgot-password-container,\r\n.reset-password-container {\r\n  animation: fadeIn 0.4s ease-out;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
